"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";
import { type EcolabLocation } from "types/ContentHub/Location";

export type LocationContextProps = {
  location?: EcolabLocation;
  locationSlug: string;
};

const LocationContext = createContext<LocationContextProps>({
  location: undefined,
  locationSlug: "",
});

interface LocationProviderProps {
  children: ReactNode;
  location?: EcolabLocation;
  locationSlug: string;
}

export const LocationProvider = ({
  children,
  location,
  locationSlug,
}: LocationProviderProps) => {
  const contextValue = useMemo(
    () => ({ location, locationSlug }),
    [location, locationSlug],
  );
  return (
    <LocationContext.Provider value={contextValue}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocationContext = (): LocationContextProps =>
  useContext(LocationContext);
